import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconHeart48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="heart">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.49031 8.74329C5.35308 6.05262 8.40214 4 13 4C16.6815 4 19.3106 5.36751 21.2022 7.30059C22.4013 8.52591 23.2883 9.96189 23.9723 11.3744C24.5894 9.97979 25.3805 8.54365 26.5172 7.31955C28.3449 5.35131 30.9923 4 35 4C37.1767 4 40.1633 4.6738 42.6273 6.65875C45.1323 8.67664 47 11.9731 47 17C47 19.2631 46.0851 21.5752 44.6775 23.8403C43.2644 26.1142 41.3033 28.4226 39.092 30.6971C35.8804 34.0004 32.0551 37.3155 28.4927 40.4027C27.1649 41.5534 25.8737 42.6724 24.6644 43.7474C24.2855 44.0842 23.7145 44.0842 23.3356 43.7474C21.7778 42.3627 20.0721 40.9259 18.3236 39.4532C15.1148 36.7504 11.7624 33.9266 8.91789 31.0821C4.54086 26.7051 1 21.9452 1 17C1 14.5975 1.66109 11.3855 3.49031 8.74329ZM5.13469 9.88171C3.58891 12.1145 3 14.9025 3 17C3 21.0548 5.95914 25.2949 10.3321 29.6679C13.1251 32.4609 16.345 35.1716 19.5043 37.8312C21.0352 39.1201 22.552 40.3969 23.9991 41.6654C25.0487 40.7402 26.1391 39.7952 27.2473 38.8348C30.7887 35.7658 34.5107 32.5402 37.658 29.3029C39.8217 27.0774 41.6731 24.8858 42.9788 22.7847C44.2899 20.6748 45 18.7369 45 17C45 12.5269 43.3677 9.82336 41.3727 8.21625C39.3367 6.5762 36.8233 6 35 6C31.5077 6 29.4051 7.14869 27.9828 8.68045C26.5106 10.2659 25.6932 12.3328 24.9363 14.3511C24.79 14.7414 24.4168 15 24 15C23.5832 15 23.21 14.7414 23.0637 14.3511C22.3288 12.3915 21.338 10.2989 19.7728 8.69941C18.2394 7.13249 16.1185 6 13 6C9.09787 6 6.64692 7.69738 5.13469 9.88171Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconHeart24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="heart">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.50004 4C4.19635 4 2.289 5.82285 2.0301 8.59096C2.02818 8.6115 2.02562 8.63198 2.02243 8.65237L2.01556 8.69632C2.00749 8.75906 1.99688 8.865 2.00083 9.05687C2.00651 9.33271 2.04498 9.76883 2.18867 10.3464C2.58619 11.9451 3.51095 13.4229 4.89254 14.6119L4.89378 14.6129L12.0001 20.6847L19.1092 14.6111L19.1103 14.6102C20.489 13.4239 21.4143 11.946 21.8114 10.3472C21.9551 9.76965 21.9936 9.33312 21.9993 9.057C22.0021 8.9187 21.9967 8.81976 21.9919 8.76252C21.9885 8.722 21.9867 8.71047 21.9844 8.69558C21.9833 8.6888 21.9821 8.68134 21.9807 8.67013C21.9791 8.65791 21.9777 8.64566 21.9765 8.63338C21.7115 5.81898 19.7993 4.00044 17.5 4.00044C15.7736 4.00044 14.1706 5.20417 13.4138 6.9063C13.4076 6.92008 13.4012 6.93372 13.3945 6.94721L12.8945 7.94721C12.7251 8.286 12.3788 8.5 12 8.5C11.6213 8.5 11.275 8.286 11.1056 7.94721L10.6056 6.94721C10.5989 6.93378 10.5925 6.9202 10.5864 6.90648C9.81898 5.18156 8.18337 4 6.50004 4ZM0.0321223 8.44649C0.381399 4.85901 2.99105 2 6.50004 2C8.80523 2 10.8454 3.38796 11.9997 5.30047C13.1362 3.4131 15.1476 2.00044 17.5 2.00044C21.0126 2.00044 23.6098 4.7903 23.9647 8.41402C23.9686 8.44081 23.978 8.51258 23.9849 8.59593C23.9953 8.71966 24.0031 8.88786 23.9988 9.0978C23.9903 9.51809 23.9332 10.1026 23.7524 10.8293C23.2476 12.8617 22.0821 14.692 20.4134 16.1274L20.4109 16.1296L12.6496 22.7603C12.2755 23.0799 11.7245 23.0799 11.3504 22.7603L3.59201 16.1313L3.58943 16.1291C1.91814 14.6912 0.753181 12.8615 0.247831 10.8292M0.0321223 8.44649C0.0321223 8.44649 -0.00746475 8.67454 0.00125458 9.09804C0.0098988 9.51789 0.0670277 10.1025 0.247831 10.8292"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconHeart16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="heart">
            <path
                d="M14.8612 6.79258C14.5742 7.93939 13.9088 8.98422 12.939 9.81216L8 14L3.06282 9.81326C2.09122 8.98367 1.42617 7.93911 1.13887 6.7923C0.932352 5.96848 1.01752 5.50008 1.01752 5.50008C1.20712 3.48821 2.64722 2 4.5 2C5.86713 2 7.1107 2.93645 7.68182 4.21053L8 4.84211L8.31819 4.21053C8.88026 2.95596 10.1005 2.00027 11.5 2.00027C13.3525 2.00027 14.7889 3.46073 14.9822 5.49871C14.9828 5.5031 15.0677 5.96876 14.8612 6.79258Z"
                stroke={props.stroke || 'currentColor'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
